import React, { Component } from 'react';

// CustomCheckbox styles are given by
// o-checkbox class, which is defined in scss/pages/custom-checkbox.scss
class CustomCheckbox extends Component {
  render() {
    let index = this.props.index,
        selected = this.props.selected,
        toggleCheckBox = this.props.toggleCheckBox,
        flex={display: 'flex', justifyContent: 'center'}
    return (
      <div className="cursor-auto o-checkbox" style={flex}>
        <input id={`styled-checkbox_${index}`} type="checkbox" value={index} checked={selected} onChange={toggleCheckBox}/>
        <label htmlFor={`styled-checkbox_${index}`}></label>
      </div>
    )
  }
}

export default CustomCheckbox;
